export default __webpack_public_path__ + "static/media/uploader-ascensiaContourNextMeter-3.6c938988.png";